import { DateInputBlock, parseTokens } from '@coast/schemas';
import moment from 'moment';
import { useMemo } from 'react';
import { useCardFormContext } from '@shared/components/blocks/contexts/form';
import { ISOString } from '@shared/scenes/cards/agenda/utils';
import { useCurrentUserId } from '@shared/util/hooks';

export function useDefaultTime(block: DateInputBlock) {
  const { values } = useCardFormContext();
  const currentUserId = useCurrentUserId();
  return useMemo(
    () =>
      parseTokens(block.defaultTime || '{today+9hours}', {
        // @ts-expect-error -- strict migration
        resolveCurrentUserId: () => currentUserId,
        resolveCard: () => values,
      }),
    [block.defaultTime, currentUserId, values],
  );
}

export function useAsISOString(value: any): ISOString {
  return useMemo((): ISOString => {
    if (!value) {
      // @ts-expect-error -- strict migration
      return undefined;
    }
    const m = moment(value);
    // @ts-expect-error -- strict migration
    return m.isValid() ? m.toISOString() : undefined;
  }, [value]);
}
